import React from 'react';
import { translate } from '../../utils/util';
import PropTypes from 'prop-types';
import '../../assets/css/module/loading.css';

const Loading = (props) => {
    return props.show ? (
        <div className="container-loading">
            <div className="ui active inverted dimmer">
                <div className="ui text loader">{props.text ? props.text : translate('loading', 'general')}</div>
            </div>
        </div>
    ) : null;
};

Loading.propTypes = {
    show: PropTypes.bool.isRequired,
};

export default Loading;
